export default {
    'menu.nomination.individual': 'Best in My Team (Nominate Individual)',
    'menu.nomination.team': 'Best in My Team (Nominate Team)',
    'nomination.onBehalfOf': 'On behalf of',
    'nomination.nominee': 'Nominee',
    'nomination.nomineeManager': 'Nominee Manager',
    'nomination.nomineeDepartment': 'Nominee Department',
    'nomination.upload': 'Upload',
    'nomination.stronglyRecommended': 'Strongly Recommended',
    'nomination.criteria': 'Criteria',
    'nomination.recognize': 'Recognize the associates who best demonstrate the company core values.',
    'nomination.coreValues': 'Core values',
    'nomination.fieldName': 'Field Name',
    'nomination.description': 'Description',
    'nomination.nominationExplanation': 'Nomination Story',
    'nomination.pleaseDescribe': 'Please describe specific reasons (Cases) to support your nomination. The length of Nomination Explanation must be between 50 characters and 2000 characters.',
    'nomination.nominatorName': 'Nominator Name',
    'nomination.nominatorDepartment': 'Nominator Department',
    'nomination.awardType': 'Award Type',
    'nomination.awardBudget': 'Award Amount'
};
